export type AppLocale = 'fr' | 'en'

const STORAGE_KEY = 'locale'

// The language a signed-out screen opens in: a choice already made on this
// device wins, then the browser's own languages — any English variant reads
// English, everything else reads French (a Québec product). After sign-in the
// profile's locale takes over (stores/auth.ts `setUser`).
export function initialLocale(
  storage: Pick<Storage, 'getItem'> = localStorage,
  languages: readonly string[] = typeof navigator === 'undefined' ? [] : navigator.languages ?? [navigator.language],
): AppLocale {
  const saved = storage.getItem(STORAGE_KEY)
  if (saved === 'fr' || saved === 'en') return saved
  const first = languages.find(Boolean)?.toLowerCase() ?? ''
  return first.startsWith('en') ? 'en' : 'fr'
}

export function persistLocale(locale: AppLocale) {
  localStorage.setItem(STORAGE_KEY, locale)
}
